import { RouterProvider, createBrowserRouter } from "react-router-dom"
import { Navigation } from "./Navigation"
import { AuthProvider, useAuth, login, refresh, getUserData, getTokenExpireDate } from "./auth"
import DataProvider from "./DataProvider"
import { DataFetchingAuthContext } from "@inmagik/react-crud"

function ProvideAuthToDataFetching({ children }: { children: React.ReactNode }) {
  const { tokens } = useAuth()

  const authHeaders: Record<string, string> = tokens?.access ? { Authorization: `Bearer ${tokens?.access}` } : {}

  return <DataFetchingAuthContext.Provider value={authHeaders}>{children}</DataFetchingAuthContext.Provider>
}

const router = createBrowserRouter([{ path: "*", element: <Root /> }])

function App() {
  return <RouterProvider router={router}></RouterProvider>
}

function Root() {
  return (
    <AuthProvider login={login} refresh={refresh} getUserData={getUserData} getTokenExpireDate={getTokenExpireDate}>
      <ProvideAuthToDataFetching>
        <DataProvider>
          <Navigation></Navigation>
        </DataProvider>
      </ProvideAuthToDataFetching>
    </AuthProvider>
  )
}

export default App
